<script>
  import * as scorePresets from '../../../../../services/score-presets';
  import {scoresStore}     from '../../../../../stores/filters/scores-store';

  export let score;

  const isInteger = score % 1 === 0;
  const isLeftColumn = score === 0.25;
  const isRightColumn = score === 3.5;

  const onClick = (_event) => {
    scoresStore.set(scorePresets.uniformScores(score));
  };
</script>

<style>
  .score-box {
    border-bottom: 1px solid #333;
    border-left: 1px solid #ccc;
    border-right: none;
    border-top: 1px solid #333;
  }
</style>

<template lang="pug" src="./all-scores-filter-score.pug"></template>
